import React, { FC, useMemo } from "react";

import {
  ExperienceTestType,
  ExperienceTestTypeDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { TestTypeIcon } from "../../../experienceTests/components/TestTypeIcon";

interface TestTypeIconArrayRenderProps {
  experienceTestTypes: ExperienceTestTypeDto;
}
export const TestTypeIconArrayRender = ({
  experienceTestTypes,
}: TestTypeIconArrayRenderProps) => {
  const applicableTestTypes = useMemo(() => {
    const testTypes: string[] = [];
    if (experienceTestTypes.hasTestContentOnsite) {
      testTypes.push("content/onsiteEdits");
    }
    if (experienceTestTypes.hasTestContentTheme) {
      testTypes.push("content/theme");
    }
    if (experienceTestTypes.hasTestContentTemplate) {
      testTypes.push("content/template");
    }
    if (experienceTestTypes.hasTestContentUrl) {
      testTypes.push("content/url");
    }
    if (experienceTestTypes.hasTestCampaign) {
      testTypes.push("personalization/offer");
    }
    if (experienceTestTypes.hasTestPricing) {
      testTypes.push("pricing");
    }
    if (experienceTestTypes.hasTestOnsiteInjections) {
      testTypes.push("content/onsiteInjections");
    }
    return testTypes;
  }, [experienceTestTypes]);

  return (
    <Grid container direction={"row"} alignItems={"center"} columnSpacing={2}>
      {applicableTestTypes.map((type) => (
        <Grid item key={type}>
          <TestTypeIcon testFlowType={type} isPersonalization={true} />
        </Grid>
      ))}
    </Grid>
  );
};
